<template>
<icon-base :width="100+'%'" :fill="color" viewBox="0 0 340.847 340.847">
    <ellipse id="Ellipse_467" data-name="Ellipse 467" cx="143.689" cy="143.689" rx="143.689" ry="143.689" transform="matrix(0.978, -0.208, 0.208, 0.978, 0, 59.749)" fill="#a7b1c6" opacity="0.18"/>
</icon-base>
</template>

<script>
export default {
    name: 'BackgroundCircle',
    components: {
        iconBase: () => import('@/common/components/iconBase.vue')
    },
    props: {
        size: {
            type: Number,
            default: 20
        },
        color: {
            type: String,
            default: ''
        },
        enableBackground: {
            type: Boolean
        }
    }
}
</script>
